import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Input, Button, useIsMobile } from '../components/ui';
import api from '../utils/api';

export default function ForgotPassword() {
  const isMobile = useIsMobile();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    if (!email.includes('@')) { setError('Enter a valid email address.'); return; }
    setLoading(true); setError('');
    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
      setSent(true);
    } catch (e) {
      // The API never reveals whether an email exists, so a request-level
      // failure here is a real error (network, rate limit) — safe to show.
      setError(e.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bb-auth-shell" style={{
      background: 'var(--gray-50)',
      alignItems: 'center', justifyContent: 'center',
      padding: isMobile ? '24px 16px' : '48px 16px',
    }}>
      <Card style={{ maxWidth: '400px', width: '100%', animation: 'bb-fadeUp 0.5s ease both' }}>
        {sent ? (
          <div style={{ textAlign: 'center', padding: '8px 0' }}>
            <div style={{ fontSize: '40px', marginBottom: '12px' }}>📬</div>
            <div style={{ fontSize: '17px', fontWeight: 700, color: 'var(--gray-900)', marginBottom: '8px' }}>Check your email</div>
            <p style={{ fontSize: '13.5px', color: 'var(--gray-500)', marginBottom: '22px', lineHeight: 1.6 }}>
              If an account exists for <strong>{email}</strong>, a password reset link is on its way. It expires in 30 minutes.
            </p>
            <Link to="/login"><Button variant="secondary" fullWidth>Back to sign in</Button></Link>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '22px' }}>
              <div style={{ fontSize: '17px', fontWeight: 700, color: 'var(--gray-900)', marginBottom: '6px' }}>Reset your password</div>
              <p style={{ fontSize: '13.5px', color: 'var(--gray-500)', lineHeight: 1.5 }}>
                Enter the email on your account and we'll send you a link to reset it.
              </p>
            </div>

            <Input
              label="Email"
              type="email"
              autoFocus
              placeholder="you@email.com"
              value={email}
              onChange={e => { setError(''); setEmail(e.target.value); }}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              error={error}
            />

            <Button variant="primary" fullWidth loading={loading} onClick={handleSubmit} style={{ marginTop: '4px' }}>
              Send reset link
            </Button>

            <p style={{ textAlign: 'center', fontSize: '13.5px', color: 'var(--gray-500)', marginTop: '18px' }}>
              <Link to="/login" style={{ fontWeight: 600, color: 'var(--red)' }}>← Back to sign in</Link>
            </p>
          </>
        )}
      </Card>
    </div>
  );
}
